import { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { D1DataUploadTable } from "./table";
import { D1DataUploadEdit } from "./edit";

export default function D1DataUpload() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Chargement de fichiers");
  }, []);

  return (
    <Routes>
      <Route path=":id" element={<D1DataUploadEdit />} />
      <Route index element={<D1DataUploadTable />} />
    </Routes>
  );
}
